import { render } from "./teachingEventDataEchart.vue?vue&type=template&id=5e1a97a2&scoped=true"
import script from "./teachingEventDataEchart.vue?vue&type=script&lang=js"
export * from "./teachingEventDataEchart.vue?vue&type=script&lang=js"

import "./teachingEventDataEchart.vue?vue&type=style&index=0&id=5e1a97a2&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1a97a2"]])

export default __exports__